import {useI18n, I18n} from '@shopify/react-i18n';

export enum JoinFormat {
  And = 'and',
  Or = 'or',
  Narrow = 'narrow',
}
type JoinFormatType = `${JoinFormat}`;

export function useListFormatter() {
  const [i18n] = useI18n();

  const formatList = (
    items: (JSX.Element | string)[],
    joinFormat: JoinFormatType = JoinFormat.And,
  ) => {
    return localizeList(i18n, items, joinFormat);
  };

  return {formatList};
}

function localizeList(
  i18n: I18n,
  items: (JSX.Element | string)[],
  joinFormat: JoinFormatType = JoinFormat.And,
) {
  const scope = {scope: 'ListFormatter'};
  switch (items.length) {
    case 0:
      return '';

    case 1:
      return items[0];

    case 2:
      return i18n.translate(`${joinFormat}.twoWordConnector`, scope, {
        firstWord: items[0],
        secondWord: items[1],
      });

    default:
      return items.reduce((list, item, itemIndex) => {
        if (itemIndex !== items.length - 1) {
          return i18n.translate(`${joinFormat}.wordConnector`, scope, {
            previousWords: list,
            anotherWord: item,
          });
        }
        return i18n.translate(`${joinFormat}.lastWordConnector`, scope, {
          previousWords: list,
          lastWord: item,
        });
      });
  }
}
